/**
 * @generated SignedSource<<aa68dc8cadb45393a0efac78ffec7d94>>
 * @relayHash d645ded839178a7d549abbdb86977b09
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d645ded839178a7d549abbdb86977b09

import type { ConcreteRequest } from 'relay-runtime';
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PendingTypeSuggestionState = "APPLIED" | "PENDING" | "REJECTED" | "%future added value";
export type RejectPendingIssueTypeSuggestionInput = {
  actorId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
  issueTypeId: string;
};
export type rejectPendingIssueTypeSuggestionMutation$variables = {
  input: RejectPendingIssueTypeSuggestionInput;
};
export type rejectPendingIssueTypeSuggestionMutation$data = {
  readonly rejectPendingIssueTypeSuggestion: {
    readonly issue: {
      readonly id: string;
      readonly pendingTypeSuggestions: ReadonlyArray<{
        readonly actor: {
          readonly id: string;
          readonly login: string;
        } | null | undefined;
        readonly issueType: {
          readonly color: IssueTypeColor;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly rationale: string | null | undefined;
        readonly state: PendingTypeSuggestionState;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type rejectPendingIssueTypeSuggestionMutation = {
  response: rejectPendingIssueTypeSuggestionMutation$data;
  variables: rejectPendingIssueTypeSuggestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rejectPendingIssueTypeSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RejectPendingIssueTypeSuggestionPayload",
        "kind": "LinkedField",
        "name": "rejectPendingIssueTypeSuggestion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PendingTypeSuggestion",
                "kind": "LinkedField",
                "name": "pendingTypeSuggestions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rejectPendingIssueTypeSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RejectPendingIssueTypeSuggestionPayload",
        "kind": "LinkedField",
        "name": "rejectPendingIssueTypeSuggestion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PendingTypeSuggestion",
                "kind": "LinkedField",
                "name": "pendingTypeSuggestions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d645ded839178a7d549abbdb86977b09",
    "metadata": {},
    "name": "rejectPendingIssueTypeSuggestionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7bfa18fdcfd07bbdaf16ea0c260631d5";

export default node;
